import forgotPassword from './forgotPassword'

const schema = {
  forgotPassword,
}

export default schema
